import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

export const useDeleteAttachment = () => {
  const queryClient = useQueryClient()
  const toast = useToast()
  const { t } = useTranslation('flat')

  const deleteAttachment = async ({
    contract_id,
    attachment_id,
    params
  }: {
    contract_id: string | number
    attachment_id: string | number
    params?: { limit?: number; offset?: number; type?: 'flat' | 'offer' }
  }) => {
    const url = `${SNA_PREFIX}contracts/${contract_id}/attachments/${attachment_id}${
      params?.type ? `?type=${params.type}` : ''
    }`
    await apiClient.delete(url, { params })
    return attachment_id
  }

  return useMutation({
    mutationFn: deleteAttachment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contracts'] })
      queryClient.invalidateQueries({ queryKey: ['offers-detail'] })
      toast.success({ message: t('toast.attachmentDeleted') })
    },
    onError: (error: any) => {
      toast.error({
        message: t('attachmentDeleteError', {
          ns: 'toast',
          error: error?.message ?? ''
        })
      })
    }
  })
}
